<script setup lang="ts">
const props = defineProps<{
  resourceId: number
  resourceType: ResourceType
  vertical?: boolean
}>()
const $toast = useToast()

const { data, refresh } = useAsyncData(
  `rewardState:${props.resourceType}:${props.resourceId}`,
  () => fetchIfResIsReward(props.resourceId, props.resourceType)
)

const { data: userInfo } = useAuth()

async function handleClick() {
  if (!userInfo.value.login) {
    useEmitter().emit('requestLogin')
    return
  }
  if (data.value?.is_reward) {
    $toast.success('已打赏过啦，不能重复打赏')
    return
  }
  useEmitter().emit('openRewardForm', {
    resourceId: props.resourceId,
    resourceType: props.resourceType
  })
}

onMounted(() => {
  useEmitter().on('rewardSuccess', ({ resourceId, resourceType, count }) => {
    if (
      resourceId === props.resourceId &&
      resourceType === props.resourceType
    ) {
      refresh()
    }
  })
})
</script>

<template>
  <m-icon
    class="m-reward-action"
    :class="{ active: data?.is_reward }"
    icon="ni ni-coin"
    :vertical="vertical"
    @click="handleClick"
  >
    <slot />
  </m-icon>
</template>

<style lang="scss" scoped>
.m-reward-action {
  cursor: pointer;
  width: 100%;
  height: 100%;
  &.active {
    color: var(--color-yellow-500);
  }
}
</style>
